import request from '@/utils/request'
import qs from 'qs'

export function getPieChart(query) {
  return request({
    url: '/report-service/v1/room-service/pie-chart',
    method: 'get',
    params: query
  })
}
export function getHistogramChart(query) {
  return request({
    url: '/report-service/v1/room-service/histogram',
    method: 'get',
    params: query
  })
}
export function getDataHouseKeeping(query) {
  return request({
    url: '/report-service/v1/room-service',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getDataHouseKeepingExcel(query) {
  return request({
    url: '/report-service/v1/room-service/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}

export function getRoomService() {
  return request({
    url: '/config-service/v1/room-service-group',
    method: 'get'
  })
}
